import React, { ErrorInfo } from 'react';
import { logger } from '../utils/logger';

interface ErrorBoundaryState { hasError: boolean; error: Error | null; }

class ErrorBoundary extends React.Component<React.PropsWithChildren<object>, ErrorBoundaryState> {
  constructor(props: React.PropsWithChildren<object>) {
    super(props);
    this.state = { hasError: false, error: null };
  }
  static getDerivedStateFromError(error: Error): ErrorBoundaryState { return { hasError: true, error }; }
  componentDidCatch(error: Error, info: ErrorInfo) { logger.error('React ErrorBoundary yakaladı:', error, info); }
  handleReload = () => { window.location.reload(); };
  render() {
    if (this.state.hasError) {
      const isChunkError = /ChunkLoadError|Loading chunk/gi.test(this.state.error?.message || '');
      return (
        <div style={{padding: '4rem 1rem', textAlign: 'center', fontFamily: 'system-ui'}}>
          <h1 style={{fontSize: '1.8rem', marginBottom: '1rem'}}>Bir şeyler ters gitti 😕</h1>
          {isChunkError ? (
            <>
              <p style={{maxWidth: 520, margin: '0 auto 1rem'}}>Dinamik yüklenen bir parça (chunk) yüklenemedi. Bu genelde yeni bir sürüm sonrası tarayıcı önbelleğindeki eski dosyalardan kaynaklanır.</p>
              <button onClick={this.handleReload} style={{background:'#2563eb', color:'#fff', border:'none', padding:'0.75rem 1.25rem', borderRadius:8, cursor:'pointer', fontSize:16}}>Sayfayı Yenile</button>
              <p style={{marginTop:'1rem', fontSize:12, opacity:0.7}}>Devam ederse Ctrl + F5 ile zorla yenileyin.</p>
            </>
          ) : (
            <>
              <p>Beklenmeyen bir hata oluştu.</p>
              <button onClick={this.handleReload} style={{background:'#2563eb', color:'#fff', border:'none', padding:'0.75rem 1.25rem', borderRadius:8, cursor:'pointer', fontSize:16}}>Yenile</button>
            </>
          )}
        </div>
      );
    }
    return this.props.children;
  }
}
export default ErrorBoundary;
